import React from 'react';
import { motion } from 'framer-motion';
const nodes = ['WEB', 'WHATSAPP', 'CRM', 'AGENDA'];
export function Problem() {
  return <section className="bg-arena py-[56px] md:py-[84px]" data-id="element-222" data-mp="15cmem9l07qec">
      <div className="max-w-[1240px] mx-auto px-6 md:px-16" data-id="element-223" data-mp="rbti5jb56l8l">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-16 items-center" data-id="element-224" data-mp="rdee9dd3uc8k">
          {/* Left: copy */}
          <motion.div initial={{
          opacity: 0,
          y: 24
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.2
        }} transition={{
          duration: 0.4,
          ease: 'easeOut'
        }} data-id="element-225" data-mp="wc7rd4ohc187">
            <span className="block font-body text-[11px] uppercase font-medium text-salvia tracking-widest mb-6" data-id="element-226" data-mp="1f6w8xwtiayrp">
              EL PROBLEMA
            </span>
            <h2 className="font-display text-[30px] md:text-[42px] font-medium text-carbon leading-[1.12] mb-6 max-w-[480px]" data-id="element-227" data-mp="27qbj047lhda3">
              Tu empresa ya tiene herramientas. El problema es que no
              trabajan juntas.
            </h2>
            <p className="font-body text-[16px] text-carbon/60 leading-[1.7] max-w-[440px] mb-6" data-id="element-228" data-mp="1hhu16gcjzyue">
              Una web genera interés. WhatsApp recibe mensajes. El CRM
              guarda contactos. El calendario organiza citas. Pero alguien
              termina conectando todo manualmente.
            </p>
            <p className="font-display text-[18px] font-medium text-verde max-w-[440px]" data-id="element-229" data-mp="1mh6yjv11wob8">
              ORIGEN convierte herramientas y procesos aislados en una
              operación digital más conectada.
            </p>
          </motion.div>

          {/* Right: structural composition — independent tools converge into one connected process, not into ORIGEN */}
          <div className="w-full max-w-[420px] mx-auto py-6" data-id="element-230" data-mp="64rlrom6xfbt">
            <div className="flex items-stretch gap-6" data-id="element-231" data-mp="225065g44qn2">
              <div className="flex flex-col gap-0 flex-grow border-r border-carbon/15 pr-6" data-id="element-232" data-mp="215v2ndbjzskp">
                {nodes.map((node, idx) => <motion.div key={node} initial={{
                opacity: 0,
                x: -12
              }} whileInView={{
                opacity: 1,
                x: 0
              }} viewport={{
                once: true,
                amount: 0.4
              }} transition={{
                duration: 0.4,
                ease: 'easeOut',
                delay: idx * 0.08
              }} className="relative flex items-center py-4 border-b border-carbon/10 last:border-b-0" data-id="element-233" data-mp="265zid14n0j9v" data-mpi={idx}>
                    <span className="font-body text-[13px] font-medium text-carbon/70" data-id="element-234" data-mp="2tvaneut0sztt">
                      {node}
                    </span>
                  </motion.div>)}
              </div>

              {/* Convergence label — the outcome, not a software node */}
              <motion.div initial={{
              opacity: 0
            }} whileInView={{
              opacity: 1
            }} viewport={{
              once: true,
              amount: 0.4
            }} transition={{
              duration: 0.4,
              ease: 'easeOut',
              delay: 0.45
            }} className="flex flex-col items-center justify-center flex-shrink-0 w-[92px] text-center" data-id="element-235" data-mp="37utjgp8k4kpr">
                <span className="font-body text-[10px] uppercase tracking-[0.12em] text-carbon/55 leading-[1.6]" data-id="element-236" data-mp="i7p4mbarz6ot">
                  PROCESO
                  <br data-id="element-237" data-mp="1fu4iz47wno85" />
                  CONECTADO
                </span>
              </motion.div>
            </div>
            <p className="text-right font-body text-[11px] text-carbon/35 tracking-wide mt-4" data-id="element-238" data-mp="1axxk1vdxfczp">
              — ORIGEN conecta el proceso
            </p>
          </div>
        </div>
      </div>
    </section>;
}